import { render, staticRenderFns } from "./CommentsMainBuildingList.vue?vue&type=template&id=3b2ead42&scoped=true&"
import script from "./CommentsMainBuildingList.vue?vue&type=script&lang=ts&"
export * from "./CommentsMainBuildingList.vue?vue&type=script&lang=ts&"
import style0 from "./CommentsMainBuildingList.vue?vue&type=style&index=0&id=3b2ead42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2ead42",
  null
  
)

export default component.exports